import { fetchApi, parseError } from '@/api/http'
import { getTenantSlug } from '@/config/tenant'
import { forceRelogin } from '@/utils/authFlow'

export interface TenantIdentidade {
  id: number
  slug: string
  nome: string
  logoUrl: string | null
  ativo: boolean
}

/** Valida empresa pelo slug (portal /e/:slug), sem exigir conta activa na resposta. */
export async function fetchTenantPortal(slug: string): Promise<TenantIdentidade> {
  const s = slug.trim().toLowerCase()
  const res = await fetchApi(`/api/tenant/portal/${encodeURIComponent(s)}`)
  const text = await res.text()
  if (!res.ok) return parseError(res, text)
  return JSON.parse(text) as TenantIdentidade
}

export async function fetchTenantIdentidade(slug?: string): Promise<TenantIdentidade> {
  const s = (slug ?? getTenantSlug()).trim().toLowerCase()
  if (!s) throw new Error('Empresa não definida. Abra o link que a sua empresa enviou.')
  const res = await fetchApi('/api/tenant/identidade', {
    headers: { 'X-Tenant-Slug': s },
  })
  const text = await res.text()
  if (!res.ok) return parseError(res, text)
  return JSON.parse(text) as TenantIdentidade
}

export async function updateTenantIdentidade(nome: string): Promise<TenantIdentidade> {
  const res = await fetchApi('/api/tenant/identidade', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-Tenant-Slug': getTenantSlug(),
    },
    body: JSON.stringify({ nome: nome.trim() }),
  })
  const text = await res.text()
  if (res.status === 401 || res.status === 403) {
    forceRelogin('admin', 'Sessão de administrador inválida ou expirada. Faça login novamente.')
  }
  if (!res.ok) return parseError(res, text)
  return JSON.parse(text) as TenantIdentidade
}
